import React, { useState, useEffect } from "react";
import "./App.css";

import Loader from "./components/Loader";

// ==========================================
// ADMIN
// ==========================================
import AdminTeamManagement from "./pages/Admin/AdminTeamManagement";

// ==========================================
// MAIN COMPONENTS
// ==========================================
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import OurWork from "./components/OurWork";
import Workflow from "./components/Workflow";
import About from "./components/About";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import FAQ from "./components/FAQ";
import ExtraHero from "./components/extrahero";
import VideoSlider from "./components/VideoSlider";
import CinematicTimeline from "./components/CinematicTimeline";
import Testimonials from "./components/Testimonials";
import ParticleBackground from "./components/ParticleBackground";
import Services from "./components/Services";
import Career from "./components/Career";

// ==========================================
// WORK SECTION
// ==========================================
import Campaigns from "./components/WorkSection/Campaigns";
import BrandFilms from "./components/WorkSection/BrandFilms";
import Commercials from "./components/WorkSection/Commercials";
import CorporateFilms from "./components/WorkSection/CorporateFilms";
import Documentaries from "./components/WorkSection/Documentaries";
import Events from "./components/WorkSection/Events";
import Podcasts from "./components/WorkSection/Podcasts";
import VisualGallery from "./components/WorkSection/VisualGallery";
import Photography from "./components/WorkSection/PhotographyCreative";

function App() {
  const currentPath = window.location.pathname;

  // ==========================================
  // LOADER
  // ==========================================
  const [loading, setLoading] = useState(
    currentPath === "/"
  );

  useEffect(() => {
    if (currentPath !== "/") {
      setLoading(false);
      return;
    }

    const timer = setTimeout(() => {
      setLoading(false);
    }, 4500);

    return () => clearTimeout(timer);
  }, [currentPath]);

  // ==========================================
  // ADMIN PAGE
  // ==========================================
  const isAdminTeamPage =
    currentPath === "/admin/team";

  // ==========================================
  // WORK PAGES
  // ==========================================
  const isCampaignPage =
    currentPath === "/campaigns";

  const isBrandFilmsPage =
    currentPath === "/brand-films";

  const isCommercialsPage =
    currentPath === "/commercials";

  const isCorporateFilmsPage =
    currentPath === "/corporate-films";

  const isDocumentariesPage =
    currentPath === "/documentaries";

  const isEventsPage =
    currentPath === "/events";

  const isPodcastsPage =
    currentPath === "/podcasts";

  const isVisualGalleryPage =
    currentPath === "/visual-gallery";

  const isPhotographyPage =
    currentPath === "/photography";

  // ==========================================
  // RENDER
  // ==========================================

  return (
    <>
      {/* ======================================
          LOADER
      ====================================== */}
      {loading && <Loader />}

      {!loading && (
        <>
          {/* ====================================
              ADMIN TEAM
          ==================================== */}
          {isAdminTeamPage ? (
            <AdminTeamManagement />

          ) : isCampaignPage ? (
            /* ====================================
               CAMPAIGNS
            ==================================== */
            <Campaigns />

          ) : isBrandFilmsPage ? (
            /* ====================================
               BRAND FILMS
            ==================================== */
            <BrandFilms />

          ) : isCommercialsPage ? (
            /* ====================================
               COMMERCIALS
            ==================================== */
            <Commercials />

          ) : isCorporateFilmsPage ? (
            /* ====================================
               CORPORATE FILMS
            ==================================== */
            <CorporateFilms />

          ) : isDocumentariesPage ? (
            /* ====================================
               DOCUMENTARIES
            ==================================== */
            <Documentaries />

          ) : isEventsPage ? (
            /* ====================================
               EVENTS
            ==================================== */
            <Events />

          ) : isPodcastsPage ? (
            /* ====================================
               PODCASTS
            ==================================== */
            <Podcasts />

          ) : isVisualGalleryPage ? (
            /* ====================================
               VISUAL GALLERY
            ==================================== */
            <VisualGallery type="social-and-vertical-films" />

          ) : isPhotographyPage ? (
            /* ====================================
               PHOTOGRAPHY
            ==================================== */
            <Photography />

          ) : (
            /* ====================================
               MAIN WEBSITE
            ==================================== */
            <div>
              <Navbar />

              <Hero />

              {/* <ExtraHero /> */}

              {/* <VideoSlider /> */}

              <OurWork />

              <About />

              <CinematicTimeline />

              <Testimonials />

              <Services />

              <Career />

              <Contact />

              {/* <FAQ /> */}

              <Footer />
            </div>
          )}
        </>
      )}
    </>
  );
}

export default App;